// What works without a connection, shown in place of the style grid when the
// connection chip is tapped. The rules themselves live in utils/fashion/offlineRules.
import React from "react";
import { offlineRules } from "../../../utils/fashion/offlineRules";

const GROUPS = [
  { status: "yes", title: "Works offline" },
  { status: "limited", title: "Works, with limits" },
  { status: "no", title: "Waits for the connection" },
];

export default function FashionOfflinePanel({ isOnline, posConfig, pricesAt, onClose, backLabel = "Back to styles" }) {
  const rules = offlineRules(posConfig, pricesAt);
  return (
    <section className="fp-panel" aria-label="Working offline">
      <div className="fp-panel-head">
        <h2 className="fp-panel-title">Working offline</h2>
        <button type="button" className="fp-btn-ghost fp-btn-sm" onClick={onClose}>
          {backLabel}
        </button>
      </div>
      <p className="fp-muted" role="status">
        {isOnline === false ? "This till is offline now." : "This till is online now."} A sale from this store's own shelves can go ahead without a connection; anything shared with other tills, stores
        or the online store waits for it.
      </p>
      {GROUPS.map((g) => {
        const list = rules.filter((r) => r.status === g.status);
        if (list.length === 0) return null;
        return (
          <React.Fragment key={g.status}>
            <h3 className="fp-lbl fp-muted">{g.title}</h3>
            <ul className="fp-panel-list" aria-label={g.title}>
              {list.map((r) => (
                <li key={r.key} className="fp-panel-row">
                  <span className="fp-panel-main">
                    <span className="fp-panel-doc">
                      <span className={`fp-off-dot is-${r.status}`} aria-hidden="true" />
                      {r.label}
                    </span>
                    <span className="fp-muted">{r.note}</span>
                  </span>
                </li>
              ))}
            </ul>
          </React.Fragment>
        );
      })}
    </section>
  );
}
